import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/assortment/launches')({
  staticData: {
    title: 'route.assortment.launches',
    crumb: 'route.assortment.launches',
    permissions: ['assortment_launches_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
